import { render, staticRenderFns } from "./WidgetCookieConsent.vue?vue&type=template&id=c38566ec&"
import script from "./WidgetCookieConsent.vue?vue&type=script&lang=js&"
export * from "./WidgetCookieConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports